import { Component, Inject, OnInit, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogModule } from '@angular/material/dialog';
import { jsonCopyObject } from 'globals/helpers/helpers';
import { JoiFile } from 'globals/store/files.model';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { DialogModule } from '@angular/cdk/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';


@Component({
    selector: 'edit-file-info',
    template: `
<div class="joi-dialog program-dialog edit-session">
  <div class="header">
    <div>{{ data.type }} link</div>
    <mat-icon (click)="dialogRef.close()">close</mat-icon>
  </div>
  <div class="file-info-body" mat-dialog-content>
    <form>
      <mat-form-field *ngIf="!data.noName" class="general">
        <input matInput name="filename" [(ngModel)]="item.filename" (ngModelChange)="checkData()" [placeholder] ="namePlaceholder">
      </mat-form-field>
      <mat-form-field class="general">
        <input matInput name="linkUrl" [(ngModel)]="item.linkUrl" (ngModelChange)="checkData()" placeholder="Full URL">
      </mat-form-field>
      <div class="url-notice">Must start with http or https</div>
      
    </form>
  </div>
  <div mat-dialog-actions>
    <button mat-button class="delete" *ngIf="!data.new" (click)="delete($event)"><icon icon="delete24"></icon></button>
    <div style="flex:1"></div>
    <button mat-button (click)="dialogRef.close()">CANCEL</button>
    <button [disabled]="!dataOk" mat-button color="primary" (click)="save()">SAVE</button>
  </div>
</div>
  `,
    styleUrls: ['file-info.scss'],
    standalone: true,
    imports: [IconComponent, MatInputModule, MatDialogModule, MatButtonModule, CommonModule, MatFormFieldModule, FormsModule, MatIconModule],
})
export class FileInfoComponent implements OnInit {
  addItem = true
  item: JoiFile
  linkTitle
  dataOk = false
  namePlaceholder = 'Title'
  pattern:RegExp = new RegExp('^https?');


  async delete(event) {
    const linkName = this.item.filename ? this.item.filename : `this ${this.data.type || 'file'}`
    const data: ConfirmDeleteData = { title: `Delete ${linkName}`, rect: event.target.getBoundingClientRect(), dialog: this.dialog }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.dialogRef.close({ action: 'delete' })
  }

  checkData() {
    // console.log({ linkUrl: this.item.linkUrl, passed: this.pattern.test(this.item.linkUrl)})
    this.dataOk = this.pattern.test(this.item.linkUrl) && (this.data.noName || !!this.item.filename)
  }

  save() {
    
    this.dialogRef.close({ action: this.data.new ? 'create' : 'update', item: this.item, index: this.data.index })
    // console.log({ item: this.item })
  } 

  constructor(
    public dialogRef: MatDialogRef<FileInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditFileInfo,
    private el:ElementRef,
    public dialog: MatDialog,
  ) {
    // console.log(jsonCopyObject(data))
    this.item = jsonCopyObject(data.item)
    this.checkData()
  }

  ngOnInit() {
    if (this.data.namePlaceholder) this.namePlaceholder = this.data.namePlaceholder
    setTimeout(() => {
      const { x, y, putOnTop } = this.data
      const height = this.el.nativeElement.firstElementChild.offsetHeight
      const screenHeight = window.innerHeight
      const tempY = y + 30
      const yPos = putOnTop ? 10 : tempY + height < screenHeight ? tempY : Math.max(0, screenHeight - height )
      console.log({ yPos, putOnTop })
      this.dialogRef.updatePosition({ top: yPos + 'px', left: x + 'px' })
    })
  }

}

export interface EditFileResult {
  action: 'update' | 'create' | 'delete'
  item?: JoiFile
  index?: number
}


export interface EditFileInfo {
  item?: JoiFile,
  x: number,
  y: number,
  index?: number
  new?: boolean
  type: string
  noName?: boolean
  namePlaceholder?: string
  putOnTop?: boolean
}
